import React from 'react';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import Disability from '../../../../Quoters/Disability/Disability';

export default function LTCData() {
  const minAge = 18;
  const maxAge = 61;

  return {
    name: 'Disability Income',
    subtitle: 'Protection For your Income',
    footerMessage: "Get disability income from start to finish completely online.",
    specs: {
      age: { min: minAge, max: maxAge },
    },
    basicInfoForm: (history) => {
      return <Disability landing history={history} />;
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAge, maxAge),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [4, 5, 6],
    faq: FaqData()
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Disability/DisabilityData.js